import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Card from 'components/card';
import TrackingSearchBar from 'components/fields/TrackingSearchBar';
import { getLotNumbers } from 'interfaces/stock';

const Tracking = () => {
    const navigate = useNavigate();
    const [lotNumbers, setLotNumbers] = useState<any>([]);
    const [filteredLotNumbers, setFilteredLotNumbers] = useState<any>([]);
    const [search, setSearch] = useState<string>('');

    const initLotNumbers = async () => {
        const res = await getLotNumbers();
        if (res) {
            setLotNumbers(res.data);
        }
    };

    useEffect(() => {
        setFilteredLotNumbers(
            lotNumbers.filter((lotNumber: any) =>
                lotNumber.toLowerCase().includes(search.toLowerCase()),
            ),
        );
    }, [search, lotNumbers]);

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/login');
        }
        initLotNumbers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Card extra={'w-full h-[500px] !p-5 border'}>
            {/* Header */}
            <div className="h-full w-full">
                <div>
                    <p className="mt-10 text-center">Traçabilité</p>
                    <h4 className="mt-2 text-2xl text-center font-bold text-navy-700 dark:text-white">
                        Quel numéro de lot souhaitez-vous suivre ?
                    </h4>
                    <div className="mt-4 flex mx-auto w-full lg:w-[70%] z-50">
                        <TrackingSearchBar
                            label="Numérot de lot*"
                            options={filteredLotNumbers}
                            onSelect={(e: any) => {
                                navigate(`/tracking/${e}`);
                            }}
                            isLoading={lotNumbers.length === 0}
                            onSearch={(e: any) => {
                                setSearch(e);
                            }}
                            inputSmall={true}
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default Tracking;
